import type { Product } from '@/hooks/useProducts';

export type SortBy = 'sku' | 'name';

export const sortProducts = (products: Product[], sortBy: SortBy): Product[] => {
  return [...products].sort((a, b) => {
    if (sortBy === 'sku') {
      return (a.sku || '').localeCompare(b.sku || '', 'sv');
    }
    return a.name.localeCompare(b.name, 'sv');
  });
};
